import titleCase from './title-case'

export default function (value) {
	if(typeof value  == 'string')
  	return value ? titleCase(value.replace(/-|_/g, ' ')) : null
  else
  	return value
}